import { Component } from '@angular/core';

@Component({
  selector: 'app-full-page',
  template: `<router-outlet></router-outlet>`,
  standalone: false,
})
export class FullPageComponent {
  constructor() {}
}
